"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _liveReviewOoxml = require("@common/utils/liveReviewOoxml");
var _redlineEngine = require("@common/utils/redline/redline-engine");
var _RedlinePreview = _interopRequireDefault(require("@common/components/remedy/RedlinePreview"));
var _liveReviewApply = require("../../utils/live-review-apply");
var _proposalEngineAccess = require("../../utils/proposal-engine-access");
var _LiveProposalPanel = _interopRequireDefault(require("../redline/LiveProposalPanel"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var NOTHING_TO_PREVIEW_MESSAGE = "The redline will be available once the review is applied.";
var LiveReviewRemedyPreview = function LiveReviewRemedyPreview(_ref) {
  var issue = _ref.issue,
    remedy = _ref.remedy,
    reviewId = _ref.reviewId,
    authHeader = _ref.authHeader,
    authorName = _ref.authorName,
    hidden = _ref.hidden,
    applied = _ref.applied;
  var _useState = (0, _react.useState)({
      status: "loading"
    }),
    _useState2 = _slicedToArray(_useState, 2),
    hydration = _useState2[0],
    setHydration = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    proposalEngineEnabled = _useState4[0],
    setProposalEngineEnabled = _useState4[1];
  (0, _react.useEffect)(function () {
    var cancelled = false;
    _proposalEngineAccess.ProposalEngineAccess.current().then(function (access) {
      if (!cancelled) setProposalEngineEnabled(access.enabled);
    }).catch(function () {
      return undefined;
    });
    return function () {
      cancelled = true;
    };
  }, []);
  var remedyRef = (0, _react.useRef)(remedy);
  remedyRef.current = remedy;
  /**
   * What the remedy is made of, as one string.
   *
   * WHY
   *   `LiveReviewWidget` polls a fresh snapshot while a review runs, and a remedy
   *   keeps its `id` while its content arrives. Keying the effect on the id alone
   *   left the first hydration in place for good — a preview seeded before the
   *   content landed stayed on "The redline will be available once the review is
   *   applied." Keying it on the content's identity instead re-runs when the
   *   content actually changes, where depending on the fields themselves would
   *   re-run on every poll: the snapshot is deserialised afresh each time, so
   *   those arrays and objects are new references even when nothing changed.
   */
  var remedyContentKey = JSON.stringify([remedy.textRedline, remedy.ooxmlAfter, remedy.trackedChanges]);
  var hydratedContentKey = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    /**
     * WHEN this content has already been hydrated
     *   CONSEQUENCE
     *     Keep the result. Resetting to "loading" here would flash the preview back
     *     to the spinner on every poll.
     */
    if (hydratedContentKey.current === remedyContentKey) return;
    hydratedContentKey.current = remedyContentKey;
    var cancelled = false;
    setHydration({
      status: "loading"
    });
    (0, _liveReviewApply.hydrateRemedyOoxml)(remedyRef.current, issue.ruleUuid, {
      authHeader: authHeader,
      reviewId: reviewId
    }).then(function (hydrated) {
      if (!cancelled) setHydration({
        status: "ready",
        remedy: hydrated
      });
    }).catch(function (error) {
      if (!cancelled) setHydration({
        status: "error",
        message: error instanceof Error ? error.message : String(error)
      });
    });
    return function () {
      cancelled = true;
    };
  }, [remedyContentKey, issue.ruleUuid, reviewId, authHeader]);
  if (hydration.status === "loading") return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "mt-2 text-[11px] italic text-[#666]",
    children: "Loading redline\u2026"
  });
  if (hydration.status === "error") {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      role: "alert",
      className: "mt-2 text-[11px] text-[#B45309]",
      children: ["Could not load redline: ", hydration.message]
    });
  }
  var hydrated = hydration.remedy;
  var markup = hydrated.textRedline === null ? (0, _liveReviewOoxml.resolveRemedyOoxml)(hydrated, {
    author: authorName !== null && authorName !== void 0 ? authorName : _redlineEngine.DIOPTRA_AUTHOR
  }) : "";
  var redlineOoxml = markup.length > 0 ? markup : null;
  if (hydrated.textRedline === null && redlineOoxml === null) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "mt-2 text-[11px] italic text-[#666]",
      children: NOTHING_TO_PREVIEW_MESSAGE
    });
  }
  if (!proposalEngineEnabled) {
    if (hidden || redlineOoxml === null) return null;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RedlinePreview.default, {
      ooxml: redlineOoxml
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LiveProposalPanel.default, {
    bookmarkNames: hydrated.targetBookmarks,
    redlineOoxml: redlineOoxml,
    textRedline: hydrated.textRedline,
    editLayer: null,
    onProposalPackage: null,
    onDocumentAlreadyReadsAsProposed: null,
    insertAfter: false,
    hidden: hidden,
    applied: applied,
    framed: true,
    "data-sentry-element": "LiveProposalPanel",
    "data-sentry-component": "LiveReviewRemedyPreview",
    "data-sentry-source-file": "LiveReviewRemedyPreview.tsx"
  });
};
var _default = exports.default = LiveReviewRemedyPreview;